/** 一見して危険種別 */
export const EXTERIOR_RISK_TYPE = {
  UNSELECTED: '-1',
  NOT_APPLICABLE: '0',
  TOTAL_OR_PARTIAL_COLLAPSE: '1',
  FOUNDATION_MAJOR_DAMAGE: '2',
  MAJOR_BUILDING_TILT: '3',
  OTHER: '9'
} as const
